import React, { useEffect, useState } from 'react'
import { Select } from 'antd'
import { getLang } from '../utils'

export function CellarSelector({ value, onChange }) {
  const [items, setItems] = useState()

  useEffect(() => {
    init()
  }, [])
  async function init() {
    const res = await searchCellars()
    setItems(res)
  }

  if (!items) return null

  return (
    <Select
      key="regions"
      showSearch
      style={{ width: '100%' }}
      placeholder="Please select a cellar"
      defaultValue={value?.length ? value : undefined}
      filterOption={(input, option) =>
        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
      }
      onChange={onChange}
    >
      {items.map((item) => (
        <Select.Option key={item.id} value={item.id}>
          {item.name}
        </Select.Option>
      ))}
    </Select>
  )
}

export async function searchCellars() {
  const res = await fetch(`/db/guillotina/@list-all-bodegas`).then((res) =>
    res.json()
  )
  return res?.map?.((item) => ({ id: item.id, name: item.nombre }))
}
